import {  ADD_NEWSLETTER_RED, DELETE_NEWSLETTER_RED, GET_NEWSLETTER_RED } from "../Constant";
const initialState = [];
export function NewsletterReducer(state = initialState, action){
    var newState
    switch (action.type) {
        case ADD_NEWSLETTER_RED:      
           return [...state, action.data];
        case GET_NEWSLETTER_RED:
            return action.data
        case DELETE_NEWSLETTER_RED:
            newState = state.filter(item=>item._id!==action.data._id)
            return newState
        default:
            return state
    }
}